import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import 'rxjs/add/observable/forkJoin';

import { ConfigurationService } from '../../shared/configuration.service';
import { LocalStorage } from '../../shared/localstorage.service';

@Component({
  selector: 'app-packet',
  templateUrl: './packet.component.html',
  styleUrls: ['./packet.component.scss']
})
export class PacketComponent implements OnInit {
    public users: user[];
    public filterValue: number;
    public selectedFilterOperation: string = '';

    private routerSub: Subscription;

    constructor(
        private ActivatedRoute: ActivatedRoute,
        private ConfigurationService: ConfigurationService,
        private localStorage: LocalStorage,
    ) {}

    ngOnInit() {
        this.routerSub = this.ActivatedRoute.params.subscribe(params => {
            if (params['filterCompletion']) {
                this.filterValue = params['filterCompletion'];
                this.selectedFilterOperation = '=';
            }

            const packetId = +params['id'];
            const state = this.localStorage.getItem('currentState');

            Observable.forkJoin(
                this.ConfigurationService.getUserPackets(packetId, state, false),
                this.ConfigurationService.getPacketQAdTicketCountsOfThisMonth(packetId, state)
            )
            .subscribe(responses => {
                var [activeUserPackets, userMonthlyQAdCounts] = responses.map(response => response.json());

                const usersByUserName: {[key:string]: user} = {};

                activeUserPackets.forEach((record: agentPacketRecord) => {
                    usersByUserName[record.userName] = {
                        ...(usersByUserName[record.userName] || {}),
                        ...record,
                        monthlyQadCount: 0,
                    };
                });

                userMonthlyQAdCounts.forEach((record: agentMontlyQaCountRecord) => {
                    usersByUserName[record.userName] = {
                        ...(usersByUserName[record.userName] || {}),
                        userName: record.userName,
                        monthlyQadCount: record.count,
                    };
                });

                this.users = Object.keys(usersByUserName).map(key => usersByUserName[key]);
            })

        });
    }

    ngOnDestroy() {
        this.routerSub.unsubscribe();
    }

    completionColumnCustomText(cellInfo) {
        return cellInfo.value !== undefined ? cellInfo.value + "%" : cellInfo.value;
    }
}

class agentPacketRecord {
    public PacketId: number;
    public userName: string;
    public PacketCompletionPercentage: number;
    public qadCount: number;
    public assignedCount: number;
    public availableCount: number;
    public creationDate: Date;
}

class agentMontlyQaCountRecord {
    userName: string;
    count: number;
}

class user {
    userName: string;
    qadCount?: number;
    assignedCount?: number;
    availableCount?: number;
    monthlyQadCount?: number;
    creationDate?: Date;
};

